var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1397 10.5593L18.0286 11.2008L14.8185 5.64151L15.9296 5L19.1397 10.5593ZM5.18945 11.2008L6.30055 10.5593L9.51066 16.1199L8.39957 16.7614L5.18945 11.2008ZM35.1903 16.7614L34.0792 16.1199L37.2893 10.5593L38.4004 11.2008L35.1903 16.7614ZM27.659 5L28.7713 5.64151L25.5612 11.2008L24.4501 10.5593L27.659 5ZM24.4514 33.4407L25.5625 32.7992L28.7726 38.3585L27.6615 39L24.4514 33.4407ZM38.4017 32.7992L37.2906 33.4407L34.0805 27.8801L35.1916 27.2386L38.4017 32.7992ZM8.40085 27.2386L9.51194 27.8801L6.30183 33.4407L5.19074 32.7992L8.40085 27.2386ZM15.9322 39L14.8198 38.3585L18.0299 32.7992L19.141 33.4407L15.9309 39H15.9322Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9503 22.6415L16.1109 27.5593L18.9503 32.4784H24.6302L27.4695 27.5593L24.6302 22.6415H18.9503ZM18.9503 21.3584H24.6302L27.4695 16.4406L24.6302 11.5215H18.9503L16.1109 16.4406L18.9503 21.3584ZM14.9986 15.7991L18.21 10.2385H25.3705L28.5806 15.7991H35.0008L38.5805 22L35.0008 28.2008H28.5806L25.3705 33.7614H18.2112L15.0011 28.2008H8.58091L5 22L8.57962 15.7991H14.9986ZM34.2592 26.9178L37.0998 22L34.2592 17.0821H28.5806L25.7426 22L28.5819 26.9178H34.2592ZM14.9998 26.9178L17.8392 22L14.9998 17.0821H9.31993L6.4806 22L9.32121 26.9178H14.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcon01);
export default __webpack_public_path__ + "static/media/pricing-icon-01.7d5f756e9da0ef4faa3182d5c9b762bf.svg";
export { ForwardRef as ReactComponent };